import _ from 'lodash';

import nextTimesComponentConfig, {REQUIRED_IMPORTS as COMPONENT_REQUIRED_IMPORTS,
  personConfig as nextTimesPersonComponentConfig,
  locationConfig as nextTimesLocationComponentConfig,
  serviceConfig as nextTimesServiceComponentConfig} from './next-times.component';
import serviceSelector from '../common/components/service-selector.component';
import locationSelector from '../common/components/location-selector.component';
import cityAdvancedSelector from '../common/components/city-advanced-selector.component';
import reservationSlotRow from '../common/components/reservation-slot-row.component';

const mod = angular.module('app.nextTimes', _.union(COMPONENT_REQUIRED_IMPORTS, [
  serviceSelector,
  locationSelector,
  cityAdvancedSelector,
  reservationSlotRow
]))

.component('nextTimes', nextTimesComponentConfig)
.component('nextTimesPerson', nextTimesPersonComponentConfig)
.component('nextTimesLocation', nextTimesLocationComponentConfig)
.component('nextTimesService', nextTimesServiceComponentConfig)

;

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/next-times/next-times.module.js